<div class="ios-instruction-banner" *ngIf="isVisible">
    <div class="banner-content">
        <div class="banner-icon">
            <i class="material-icons">info_outline</i>
        </div>
        <div class="banner-text">
            <p class="banner-title">Para receber notificações, adicione o app à sua tela inicial</p>
            <p class="banner-steps">
                1. Toque no botão <strong>Compartilhar</strong> <svg fill="none" width="16" height="16"
                    viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z" />
                    <path d="M24 7h2v21h-2z" />
                    <path
                        d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z" />
                </svg> na parte inferior<br>
                2. Selecione <strong>"Adicionar à Tela de Início"</strong><br>
                3. Toque em <strong>"Adicionar"</strong>
            </p>
            <button class="dismiss-permanent" (click)="dismissPermanently()">
                Não mostrar novamente
            </button>
        </div>
        <div class="banner-actions">
            <button class="dismiss" (click)="dismiss()">
                <i class="material-icons">close</i>
            </button>
        </div>
    </div>
</div>